import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import {
  initializeFirestore,
  memoryLocalCache,
  persistentLocalCache,
  persistentMultipleTabManager
} from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyD7dWWkti-w2mDWYjvKocF_MD0qjT4R_RM",
  authDomain: "streamamine.firebaseapp.com",
  projectId: "streamamine",
  storageBucket: "streamamine.firebasestorage.app",
  messagingSenderId: "797885566669",
  appId: "1:797885566669:web:021e930882eebf767b2384",
  measurementId: "G-H72M1L0WWP"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
// WebKit (Safari, PWA e app su iPhone/iPad) chiude le transazioni IndexedDB quando
// la pagina va in background; al ritorno la cache persistente di Firestore fallisce
// con "INTERNAL ASSERTION FAILED (b815) ... without an in-progress transaction" e il
// client resta inutilizzabile fino al ricaricamento. Li' si tiene la cache in memoria:
// l'offline lo copre gia' la copia in localStorage di dataService.
const ua = typeof navigator !== "undefined" ? navigator.userAgent : "";
const isWebKit =
  /iPad|iPhone|iPod/.test(ua) ||
  (/Macintosh/.test(ua) && typeof navigator !== "undefined" && navigator.maxTouchPoints > 1) ||
  (/Safari/.test(ua) && !/Chrome|Chromium|CriOS|Android|Edg|OPR|Firefox/.test(ua));

// Interfaccia TV (src/tv): li' 'firebase/firestore' e' sostituito da src/tv/firestoreRest.js
// (API REST, vite.tv.config.js), che ignora la cache; il segnale resta per sicurezza.
const isTvApp = typeof window !== "undefined" && window.__NOTFLIX_TV__ === true;

export const db = initializeFirestore(app, {
  localCache: isWebKit || isTvApp
    ? memoryLocalCache()
    : persistentLocalCache({
        tabManager: persistentMultipleTabManager()
      })
});
